export const queryKeys = {
  auth: {
    user: ['auth', 'user'] as const,
  },
  attachmentComments: (documentId: string) =>
    ['attachment-comments', documentId] as const,
  qcFindings: (documentId: string) =>
    ['qc-check-findings', documentId] as const,
  allQcFindings: (documentId: string) =>
    ['qc-all-check-findings', documentId] as const,
  qcFindingReviews: (documentId: string) =>
    ['qc-finding-reviews', documentId] as const,
  implicitAiComments: (documentId: string) =>
    ['implicit-ai-comments', documentId] as const,
  documentOverlays: (documentId: string) =>
    ['document-overlays', documentId] as const,
  qcOverlays: (documentId: string) => ['qc-overlays', documentId] as const,
  documentMeasurements: (documentId: string) =>
    ['document-measurements', documentId] as const,
  annotationHistory: (annotationId: string) =>
    ['annotation-history', annotationId] as const,
  annotationLayerHistory: (layerId: string) =>
    ['annotation-layer-history', layerId] as const,
  cityClerks: {
    all: ['cityClerks'] as const,
  },
  projects: {
    list: (cityId: string, pageNumber: number, pageSize: number) =>
      ['projects', cityId, pageNumber, pageSize] as const,
    detail: (projectId: string) => ['projects', 'detail', projectId] as const,
  },
  templates: {
    list: (cityId: string, pageNumber: number, pageSize: number) =>
      ['templates', cityId, pageNumber, pageSize] as const,
  },
  roles: {
    all: ['roles'] as const,
    byCity: (cityKey: string) => ['roles', cityKey] as const,
  },
} as const
